// removed by extract-text-webpack-plugin
module.exports = {"horizontalScrollContainer":"horizontalScrollContainer__XxKgS"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/common/horizontalScroll/style.css
// module id = 3bIs
// module chunks = 323 325 331 341 342 344 368